import {
    UPDATE_ORDER,
    UPDATE_ORDER_FAILURE,
    UPDATE_ORDER_SUCCESS,

    AMEND_ORDER,
    AMEND_ORDER_FAILURE,
    AMEND_ORDER_SUCCESS,
} from 'store/actions/types';

// Update Orders
export const updateOrder = (payload) => {
    return {
        type: UPDATE_ORDER,
        payload: payload,
    };
};

export const updateOrderFailure = (error) => {
    return {
        type: UPDATE_ORDER_FAILURE,
        error: error,
    };
};

export const updateOrderSuccess = (id, response) => {
    return {
        type: UPDATE_ORDER_SUCCESS,
        id: id,
        response: response,
    };
};

// Amend Orders
export const amendOrder = (payload) => {
    return {
        type: AMEND_ORDER,
        payload: payload,
    };
};

export const amendOrderFailure = (error) => {
    return {
        type: AMEND_ORDER_FAILURE,
        error: error,
    };
};

export const amendOrderSuccess = (id, response) => {
    return {
        type: AMEND_ORDER_SUCCESS,
        id: id,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/orders/updateOrders.js